import Trigger from 'eflex/models/trigger';

export default class TurckIoTrigger extends Trigger {}
